<accredible-base-footer *transloco="let t; lang: 'en|static' read: 'chromeoscertifieddirectory_accredible_com.footer'">
  <div class="content">
    <div class="footer-logo-container">
      <a href="https://chromeoscertification.com/chromeos-administrator/">
        <img [alt]="t('issuer_logo')"
          class="branding-logo"
          src="assets/themes/chromeoscertifieddirectory.accredible.com/images/chrome-os-logo-bw.svg">
      </a>
    </div>

    <div class="links">
      <nav class="footer-nav"
        role="navigation"
        [attr.aria-label]="t('aria_accredible_links')">
        <ul>
          <li>
            <a href="https://policies.google.com/terms"
              target="_blank">
              {{ t('terms_of_service') }}
            </a>
          </li>

          <li>
            <a href="https://policies.google.com/privacy"
              target="_blank">
              {{ t('privacy_policy') }}
            </a>
          </li>
        </ul>
      </nav>
    </div>
  </div>
</accredible-base-footer>
